
<template>
  <v-container>
    <v-row class="text-center">
      

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">
          IT Software Development
        </h1>

        <p class="subheading font-weight-regular"></p>
         <h1> Full Stack Developer</h1>
         <h3>Rafael Beltran M.</h3>          
          
          <br>Office: +52-656-692-8788 Ext 8608
          <br>VOIP: 5290-8608
          <br>Cell: +52-1-656-311-3677
          <br>rafael.beltran@foxconn.com
       
      </v-col>

   

       <!-- DFMS Links. <<Ini>> -->
      <template v-if="isDfms">
        <v-col class="mb-5" cols="12" >
          <h2 class="headline font-weight-bold mb-3">
            Important Links Dell
          </h2>
          <v-row justify="center">
            <a
              v-for="(link, i) in importantLinksDell"
              :key="i"
              :href="link.href"
              class="subheading mx-3"
              target="_blank"
            >
              {{ link.text }}
            </a>
          </v-row>
        </v-col>
      </template>
      <!-- DFMS Links. <<End>> -->

      <!-- HP Links. <<Ini>> -->
      <template v-if="isHP">
        <v-col class="mb-5" cols="12" >
          <h2 class="headline font-weight-bold mb-3">
            Important Links HP
          </h2>
          <v-row justify="center">
            <a
              v-for="(linkHP, i) in importantLinksHP"
              :key="i"
              :href="linkHP.href"
              class="subheading mx-3"
              target="_blank"
              
            >
              {{ linkHP.text }}
            </a>
          </v-row>
        </v-col>
      </template>
      <!-- HP Links. <<End>> -->

      <!-- CUSTOMS-YMS Links. <<Ini>> -->
      <template v-if="isCustoms">
        <v-col class="mb-5" cols="12" >
          <h2 class="headline font-weight-bold mb-3">
            Important Links Customs-YMS
          </h2>
          <v-row justify="center">
            <a
              v-for="(linkCustoms, i) in importantLinksCustom"
              :key="i"
              :href="linkCustoms.href"
              class="subheading mx-3"
              target="_blank"              
            >
              {{ linkCustoms.text }}
            </a>
          </v-row>
        </v-col>
      </template>
      <!-- CUSTOMS-YMS Links. <<End>> -->

    </v-row>
  </v-container>
</template>


<script>
  export default {
    name: 'HelloWorld',

    data: () => ({
    
      importantLinksDell: [
        {
          text: 'Warehouse',
          href: 'http://10.13.8.220/WareHouse/WareHouseMain.aspx',
        },
        {
          text: 'Hotel Kanban',
          href: 'http://10.13.8.220/ODHotel/HotelKanBan.aspx',
        },
        {
          text: 'Sap Order Import',
          href: 'http://10.13.8.220/SAPOrderImport/OrderImportMain.aspx',
        },        
        {
          text: 'Shift Performance',
          href: 'http://10.13.7.145:843/ShiftPerformance/ShiftPerformance',
        },        
      ],
       importantLinksHP: [
        {
          text: 'Warehouse',
          href: 'http://10.13.0.200:8081/warehouse.aspx',
        },
        {
          text: 'Hotel Kanban',
          href: 'http://10.13.7.161/HotelKanban/hotel_kanban.aspx',
        },             
      ],
      importantLinksCustom: [
        {
          text: 'YMS',
          href: 'http://10.13.8.220:8099/login.aspx',
        },
        {
          text: 'Shipping Report from Codice',
          href: 'http://10.13.8.220/codice/',
        },             
      ],
      whatsNext: [
        {
          text: 'Quality Defect System  [2020011010000799]',
          href: '',
        },
        {
          text: 'Workmanship Alert  [2020011010000806]',
          href: '',
        },        
      ],
    }),
     computed: {
       isDfms(){
        return this.$store.state.user 
          && (this.$store.state.user.rol.indexOf('_dfms') >-1  || this.$store.state.user.rol.indexOf('_all') >-1) ;
      },
       isHP(){
        return this.$store.state.user 
          && (this.$store.state.user.rol.indexOf('_hp') >-1  || this.$store.state.user.rol.indexOf('_all') >-1) ;
      },
       isCustoms(){
        return this.$store.state.user 
          && (this.$store.state.user.rol.indexOf('_customs') >-1  || this.$store.state.user.rol.indexOf('_all') >-1) ;
      }
     }
  }
</script>
